/**
 * Column Aliases Management
 *
 * Type definitions and utility functions for managing custom display names
 * for metric columns in list views.
 *
 * Note: Storage is now handled via useOrganizationLocalStorage hook in components.
 * These utilities operate on already-loaded alias data.
 */

// Type definitions
export type ColumnAliases = Record<string, string>; // { columnId: aliasName }

/**
 * Get the display title for a column, using alias if available
 */
export function getColumnDisplayTitle(
  columnId: string,
  originalTitle: string,
  aliases: ColumnAliases,
): string {
  return aliases[columnId] || originalTitle;
}

/**
 * Check if a column has an alias set
 */
export function hasColumnAlias(
  columnId: string,
  aliases: ColumnAliases,
): boolean {
  return Boolean(aliases[columnId]);
}
